
import React from "react";

interface MyceliumProps {
  className?: string;
  size?: number | string;
  color?: string;
  strokeWidth?: number;
}

const Mycelium: React.FC<MyceliumProps> = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Circle outline */}
      <circle cx="12" cy="12" r="10" strokeWidth={strokeWidth} fill="none" />
      
      {/* Mushroom cap */}
      <path 
        d="M12,6 C9,6 7,8 7,9.5 C7,11 9,12 12,12 C15,12 17,11 17,9.5 C17,8 15,6 12,6Z" 
        fill={color} 
        stroke="none"
      />
      
      {/* Mushroom stem */}
      <path 
        d="M12,12 L12,14" 
        strokeWidth={strokeWidth}
      />
      
      {/* Mycelium roots */}
      <path d="M12,14 L9,16 L8,18" strokeWidth={strokeWidth} />
      <path d="M12,14 L10,17 L10,19" strokeWidth={strokeWidth} />
      <path d="M12,14 L12,17 L12,19" strokeWidth={strokeWidth} />
      <path d="M12,14 L14,17 L14,19" strokeWidth={strokeWidth} />
      <path d="M12,14 L15,16 L16,18" strokeWidth={strokeWidth} />
      
      {/* Root nodes */}
      <circle cx="8" cy="18" r="0.5" fill={color} />
      <circle cx="10" cy="19" r="0.5" fill={color} />
      <circle cx="12" cy="19" r="0.5" fill={color} />
      <circle cx="14" cy="19" r="0.5" fill={color} />
      <circle cx="16" cy="18" r="0.5" fill={color} />
    </svg>
  );
};

export default Mycelium;
